import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import moment from 'moment';

const TrashIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
            fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5"
            fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M9.5 16.5L9.5 10.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M14.5 16.5L14.5 10.5" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </SvgIcon>
);

const PencilIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
            fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

const useStyles = makeStyles((theme) => ({
    noteCard: {
        padding: "10px 12px",
        borderRadius: 10,
        background: theme.mode === "light" ? "#fff" : "#233039",
        border: theme.mode === "light" ? "1px solid #e8e8e8" : "1px solid #2a3942",
        marginBottom: 8,
        position: "relative",
        "&:last-child": {
            marginBottom: 0,
        },
    },
    noteText: {
        fontSize: 13,
        color: theme.mode === "light" ? "#111b21" : "#e9edef",
        lineHeight: 1.4,
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        paddingRight: 64,
    },
    noteFooter: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 6,
    },
    noteMeta: {
        fontSize: 11,
        color: theme.mode === "light" ? "#8696a0" : "#8696a0",
    },
    actionBtn: {
        position: "absolute",
        top: 6,
        padding: 4,
        opacity: 0.4,
        transition: "opacity 0.2s, color 0.2s",
        "&:hover": {
            opacity: 1,
        },
    },
    deleteBtn: {
        right: 4,
        "&:hover": {
            color: theme.palette.error.main,
        },
    },
    editBtn: {
        right: 32,
        "&:hover": {
            color: theme.palette.primary.main,
        },
    },
}));

export default function ContactNotesDialogListItem(props) {
    const { note, deleteItem, editItem } = props;
    const classes = useStyles();

    return (
        <div className={classes.noteCard}>
            <Typography className={classes.noteText}>
                {note.note}
            </Typography>
            <div className={classes.noteFooter}>
                <Typography className={classes.noteMeta}>
                    {note.user.name} - {moment(note.createdAt).format('DD/MM/YY HH:mm')}
                </Typography>
            </div>
            {editItem && (
                <IconButton
                    className={`${classes.actionBtn} ${classes.editBtn}`}
                    onClick={() => editItem(note)}
                    size="small"
                    aria-label="edit"
                >
                    <PencilIcon style={{ fontSize: 16 }} />
                </IconButton>
            )}
            <IconButton
                className={`${classes.actionBtn} ${classes.deleteBtn}`}
                onClick={() => deleteItem(note)}
                size="small"
                aria-label="delete"
            >
                <TrashIcon style={{ fontSize: 16 }} />
            </IconButton>
        </div>
    );
}

ContactNotesDialogListItem.propTypes = {
    note: PropTypes.object.isRequired,
    deleteItem: PropTypes.func.isRequired,
    editItem: PropTypes.func,
}
